import { Col, Row, Typography } from "@commonlibs";
import InfoPopover from "ui/common/components/feedback/InfoPopover/InfoPopover";
import useTranslate from "ui/locale/hooks/useTranslate";


type GiftCardExpireTooltipType = {
    date: string;
    month_threshold?: number
}

export const GiftCardExpireTooltip = ({ date, month_threshold = 1 }: GiftCardExpireTooltipType) => {
    const translate = useTranslate();
    const isNearExpiry = (() => {
        const expiryDate = new Date(date);
        const now = new Date();
        const threshold = new Date();
        threshold.setMonth(threshold.getMonth() + month_threshold);
        return expiryDate > now && expiryDate <= threshold;
    })();

    return (
        <Row alignItems={"center"} justifyContent="center" gap={5}>
            <Col>
                <Typography variant={"body1Regular"}>
                    {date}
                </Typography>
            </Col>
            {isNearExpiry && (
                <Col>
                    <InfoPopover
                        text={translate("nearExpiryDescription")} />
                </Col>
            )}
        </Row>
    )
}